import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function AttributionPrimes() {
    const [primes, setPrimes] = useState([]);
    const [salaries, setSalaries] = useState([]);
    const [beneficiaires, setBeneficiaires] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedPrime, setSelectedPrime] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // Utilisation de la configuration centralisée
    const API_BASE = `${config.apiBase}/rh`;

    useEffect(() => {
        fetchPrimes();
        fetchSalaries();
    }, []);

    const fetchPrimes = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/lister_primes.php`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) setPrimes(data.primes);
        } catch (error) {
            toast.error('Erreur chargement primes');
        } finally {
            setLoading(false);
        }
    };

    const fetchSalaries = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/lister_salaries.php`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) setSalaries(data.salaries);
        } catch (error) {
            toast.error('Erreur chargement salariés');
        }
    };

    const openModal = async (prime) => {
        setSelectedPrime(prime);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/lister_beneficiaires.php?id_prime=${prime.id_prime}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) setBeneficiaires(data.beneficiaires);
        } catch (error) {
            toast.error('Erreur chargement bénéficiaires');
        }
        setShowModal(true);
    };

    const toggleSalarie = (idSalarie) => {
        setBeneficiaires(prev =>
            prev.includes(idSalarie)
                ? prev.filter(id => id !== idSalarie)
                : [...prev, idSalarie]
        );
    };

    const saveAttribution = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/associer_prime.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({
                    id_prime: selectedPrime.id_prime,
                    salaries: beneficiaires
                })
            });
            const data = await res.json();
            if (data.success) {
                toast.success('Attribution mise à jour');
                setShowModal(false);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Erreur lors de l\'enregistrement');
        }
    };

    if (loading) return <div className="p-6 text-center">Chargement...</div>;

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold text-blue-800 mb-6">🎁 Attribution des primes et indemnités</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {primes.map(prime => (
                    <button
                        key={prime.id_prime}
                        onClick={() => openModal(prime)}
                        className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition transform"
                    >
                        <div className="text-2xl mb-1">🎁</div>
                        {prime.nom_prime}<br />
                        <span className="text-sm opacity-90">{parseInt(prime.valeur).toLocaleString()} FCFA</span>
                    </button>
                ))}
            </div>

            {showModal && selectedPrime && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl w-full max-w-2xl max-h-[80vh] overflow-y-auto p-6">
                        <h2 className="text-xl font-bold mb-4">🎁 {selectedPrime.nom_prime} – Bénéficiaires</h2>
                        <div className="space-y-2 mb-4">
                            {salaries.map(s => (
                                <label key={s.id_salarie} className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded">
                                    <input
                                        type="checkbox"
                                        checked={beneficiaires.includes(s.id_salarie)}
                                        onChange={() => toggleSalarie(s.id_salarie)}
                                        className="w-5 h-5"
                                    />
                                    <span className="font-medium">{s.nom} {s.prenom}</span>
                                </label>
                            ))}
                        </div>
                        <div className="flex justify-end gap-2 mt-4">
                            <button onClick={() => setShowModal(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Annuler</button>
                            <button onClick={saveAttribution} className="bg-green-600 text-white px-4 py-2 rounded">Enregistrer</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}